import * as z from 'zod';

export const filterValueNonNullSchema = z.union([
  z.string(),
  z.boolean(),
  z.number(),
]);
// NOTE: we use FilterValue in generated graphql types so don't rename it without also changing it in graphql.config.ts
// also be aware the changing this type (or the schema it comes from! filterValueNonNullSchema) will change both the input and output type of filters in generated graphql types
export type FilterValue = z.infer<typeof filterValueNonNullSchema>;
